<template>
  <transition :enter-active-class="transition.enter" :leave-active-class="transition.leave">
    <div v-show="isActive" class="toast" :class="[position, computedClasses]">
      <div v-html="message" />
    </div>
  </transition>
</template>

<script>
  import { defineComponent } from 'vue';
  import NoticeMixin from '../../../utils/mixins/noticeMixin.js';
  import GeneralMixin from '../../../utils/mixins/generalMixin';

  /**
  * @displayName Toast
  */
  export default defineComponent({
    name: 'DToast',
    mixins: [NoticeMixin, GeneralMixin],
    data() {
      return {
        newDuration: this.duration,
      };
    },

    computed: {
      computedClasses() {
        return {
          [`toast-${this.color}`]: true,
        };
      },
    },
  });
</script>